import { useEffect, useState } from 'react';

import { useModelingPerformanceQuery } from '@/hook';
import type { FrameGraphData, Modeling, ObjectTypeData } from '@/type';

import ModelingDataSummary from './ModelingDataSummary';
import ModelingGraph from './ModelingGraph';
import ModelingVideo from './ModelingVideo';

const ModelingPerformance = ({ modeling }: { modeling: Modeling }) => {
  const [selectedLabel, setSelectedLabel] = useState<string[]>([]);
  const [filterableLabel, setFilterableLabel] = useState<string[]>([]);
  const { data: performance, isLoading } = useModelingPerformanceQuery(
    modeling.id,
  );

  const toggleLabel = (label: string) => {
    if (selectedLabel.includes(label)) {
      setSelectedLabel(selectedLabel.filter(l => l !== label));
    } else {
      setSelectedLabel([...selectedLabel, label]);
    }
  };

  useEffect(() => {
    if (performance?.graphData) {
      // TODO: 하드코딩 제거
      const labelList = ['vehicle', 'pedestrian', 'cyclist'];
      const filterableLabelList = labelList.filter(label =>
        performance.graphData.some(
          graphData =>
            (graphData[label as keyof FrameGraphData] as ObjectTypeData).view,
        ),
      );
      setFilterableLabel(filterableLabelList);
    }
  }, [performance?.graphData]);

  useEffect(() => {
    setSelectedLabel(filterableLabel);
  }, [filterableLabel]);

  // TODO: 하드코딩 제거
  const graphData = performance?.graphData.at(0);

  return (
    <div className="flex h-full flex-col gap-6 overflow-x-hidden overflow-y-auto @lg:grid @lg:grid-cols-2 @lg:[grid-template-rows:auto_834px] @lg:gap-x-4 @lg:gap-y-6">
      {graphData && (
        <ModelingDataSummary
          frameGraphData={graphData}
          selectedLabel={selectedLabel}
          toggleLabel={toggleLabel}
          filterableLabel={filterableLabel}
        />
      )}

      {graphData && (
        <ModelingGraph
          graphDataList={performance?.graphData ?? []}
          selectedLabel={selectedLabel}
          toggleLabel={toggleLabel}
        />
      )}

      {!isLoading && <ModelingVideo src={performance?.mp4Path ?? ''} />}
    </div>
  );
};

export default ModelingPerformance;
